import data from '../../assets/json/users.json';
import { API_TIMEOUT } from '../../config/app';
import { catalog, objectId } from './catalog';
import { faker } from '@faker-js/faker';
import { encrypt } from './password';

const seed = data
    .map((user) => ({
        ...user,
        id: objectId(),
        password: encrypt(user.password)
    }))
    .concat(
        Array.from(Array(100).keys()).map(() => {
            return {
                id: objectId(),
                role: 'user',
                name: faker.name.findName(),
                email: faker.internet.email(),
                password: encrypt('secret')
            };
        })
    );

export const User = catalog('users', seed);

export const list = ({ filter = '', role = '', page = 1, size = 10 }) => {
    filter = filter.toLowerCase();
    role = role.toLowerCase();
    return new Promise((resolve, reject) => {
        const users = User.all();
        const query = users
            .filter((user) => user.role.toLowerCase().includes(role))
            .filter(
                (user) =>
                    user.name.toLowerCase().includes(filter) ||
                    user.email.toLowerCase().includes(filter)
            );
        const start = (page - 1) * size;
        const end = start + size;
        const total = query.length;
        const records = query.slice(start, end);
        setTimeout(() => {
            resolve({
                success: true,
                data: {
                    page,
                    size,
                    total,
                    records
                }
            });
        }, API_TIMEOUT);
    });
};

export const get = (id) => {
    return new Promise((resolve, reject) => {
        const user = User.find(id);
        setTimeout(() => {
            resolve({
                success: true,
                data: {
                    record: user
                }
            });
        }, API_TIMEOUT);
    });
};

export const create = (item) => {
    return new Promise((resolve, reject) => {
        const user = {
            role: 'user',
            ...item,
            id: objectId(),
            password: encrypt(item.password)
        };
        User.add(user);
        setTimeout(() => {
            resolve({
                success: true,
                message: 'User created successfully.',
                data: {
                    record: user
                }
            });
        }, API_TIMEOUT);
    });
};

export const update = (item) => {
    return new Promise((resolve, reject) => {
        const current = get(item.id);
        item.password = item.password ? encrypt(item.password) : current.password;
        User.update(item.id, item);
        setTimeout(() => {
            resolve({
                success: true,
                message: 'User updated successfully.'
            });
        }, API_TIMEOUT);
    });
};

export const remove = (id) => {
    return new Promise((resolve, reject) => {
        User.remove(id);
        setTimeout(() => {
            resolve({
                success: true,
                message: 'User deleted successfully.'
            });
        }, API_TIMEOUT);
    });
};
